import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { IconButton, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import React, { memo, useMemo, useRef, useState } from 'react';
import useBackwardsCompatible from '../../../../../hooks/useBackwardsCompatible';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import useStyles from "../styles";
import SelectDealOwnerModal from '../../../../modals/home-table-view/SelectDealOwnerModal';

const OwnerCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const { dashboardOwner } = useBackwardsCompatible();
    const [fieldHover, setFieldHover] = useState<boolean>(false);
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const dealOwnerRef = useRef<HTMLElement>(null);

    const owner = useMemo(() => dashboardOwner(dashboard), [dashboard, dashboardOwner]);

    return (<>
        <Stack width="100%" ref={dealOwnerRef} onMouseLeave={() => setFieldHover(false)}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                onMouseEnter={() => setFieldHover(true)}>
                <Stack direction="row" spacing={1} alignItems="stretch" justifyContent="flex-start">
                    {(!!owner?.name || !!owner?.email) ? (<>
                        <PersonOutlineOutlinedIcon sx={{ width: 24, height: 24, fill: "rgb(163, 167, 172)" }} />
                        <Stack direction="column" alignItems="flex-start" justifyContent="center">
                            {!!owner?.name && (
                                <Typography className={classes.label}>
                                    {owner?.name}
                                </Typography>
                            )}
                            {/* {!!owner?.email && (
                                <Typography className={classnames(classes.label, classes.sublabel)}>
                                    {owner?.email}
                                </Typography>
                            )} */}
                        </Stack>
                    </>) : (
                        <Typography className={classnames(classes.label, classes.sublabel)} pl={4}>
                            {'No deal owner'}
                        </Typography>
                    )}
                    </Stack>
                    {fieldHover && (
                        <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                            <IconButton disableRipple
                                onClick={() => setEditModalOpen(true)}
                                sx={{ padding: 'unset !important'}}>
                                <EditOutlinedIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                            </IconButton>
                        </Stack>
                    )}
            </Stack>
        </Stack>
        {editModalOpen && (
            <SelectDealOwnerModal
                open={editModalOpen}
                dashboard={dashboard}
                anchorElement={dealOwnerRef.current}
                onClose={() => setEditModalOpen(false) } />
        )}
    </>);
}

export default memo(OwnerCell);
